import React from 'react';

import { alineDefaultFontFamily } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  circle: {
    alignItems: 'center',
    background: '#146EE8',
    borderRadius: '50%',
    display: 'flex',
    height: 32,
    justifyContent: 'center',
    padding: theme.spacing(1),
    width: 32,
  },
  number: {
    color: '#F0F0F0',
    fontFamily: alineDefaultFontFamily,
    fontSize: 24,
    fontWeight: 600,
    lineHeight: 32,
  },
}));

export function NumberBadge({ n }: { n: number }) {
  const { classes } = useStyles();

  return (
    <div className={classes.circle}>
      <span className={classes.number}>{n}</span>
    </div>
  );
}
